import { render, staticRenderFns } from "./TotalCard.vue?vue&type=template&id=290c913a&scoped=true"
import script from "./TotalCard.vue?vue&type=script&lang=js"
export * from "./TotalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290c913a",
  null
  
)

export default component.exports